module.exports = __webpack_public_path__ + "img/AS.7635b7b9.png";